import axios from 'axios';
import { toast } from '@/utils/toast.js';
import { initShopOptions, getShopOptions } from '@/utils/shopOptions';

// 创建axios实例
const request = axios.create({
  baseURL: getShopOptions().webapiurl,
  timeout: 15000,
});

// 请求拦截器
request.interceptors.request.use(
  async config => {
    const shopOptions = await initShopOptions();
    config.baseURL = shopOptions.webapiurl;

    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    } else if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return response.data;
    }

    const res = response.data;
    if (res.success) {
      return res;
    }
    if (res.code === 401 || res.code === 'ERR_NETWORK') {
      localStorage.removeItem('token');
      window.location.href = '/login';
      return Promise.reject(new Error('Token已过期，请重新登录'));
    }
    return Promise.reject(new Error(res.message || '请求失败'));
  },
  error => {
    console.error('请求错误:', error);

    if (error.config && error.config.responseType === 'blob' && error.response) {
      if (error.response.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = function () {
          try {
            const errorData = JSON.parse(reader.result);
            console.error('Blob响应错误:', errorData);
          } catch (e) {
            console.error('无法解析Blob错误信息:', reader.result);
          }
        };
        reader.readAsText(error.response.data);
      }
      return Promise.reject(new Error('文件下载失败，请检查网络连接或联系管理员'));
    }

    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('isLoggedIn');
        window.location.href = '/login';
        return Promise.reject(new Error('登录已过期，请重新登录'));
      } else if (error.response.status === 403) {
        if (error.response.data?.code === 'COMPANY_EXPIRED') {
          localStorage.setItem('companyExpired', JSON.stringify(error.response.data?.data || {}));
        }
        const errorMessage = error.response.data?.message || '您没有权限访问此资源';
        toast.error(errorMessage);
        return Promise.reject(new Error(errorMessage));
      }
    }

    if (error.code === 'ERR_NETWORK') {
      return Promise.reject(new Error('网络连接失败，请检查网络设置'));
    }

    return Promise.reject(error);
  }
);

export default request;